import generateUtilityClass from "../generateUtilityClass/index.js";
export default function generateUtilityClasses(componentName, slots) {
    let globalStatePrefix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'Mui';
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
    });
    return result;
}
